import type { ReactElement } from 'react';
import { Accountants } from './Accountants';
import { AddNewAccountants } from './AddNewAccountants';
import { AuthoriseCode } from './AuthoriseCode';
import { DataSecurity } from './DataSecurity';
import { Emialtemplates } from './Emialtemplates';
import { Logoonreport } from './Logoonreport';
import { Reportformat } from './Reportformat';
import { UpdateDirectors } from './UpdateDirectors';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/settings/authorisation-codes': <AuthoriseCode />,
  '/home/settings/reports-formate': <Reportformat />,
  '/home/settings/accountants': <Accountants />,
  '/home/settings/addaccountants': <AddNewAccountants />,
  '/home/settings/email-templates': <Emialtemplates />,
  '/home/settings/logo-report': <Logoonreport />,
  '/home/settings/data-security': <DataSecurity />,
  '/home/settings/update-directors': <UpdateDirectors />,
};
